import { useQuery } from "@tanstack/react-query";
import { getApiBaseUrl } from "@/config/api";
import { summarizeSavedMask } from "@/predictions/savedCardGeometry";

export function useSavedCardGeometry(maskUrl: string | null | undefined, revision: number) {
  return useQuery<Awaited<ReturnType<typeof summarizeSavedMask>>>({
    queryKey: ["saved-card-geometry", maskUrl, revision],
    enabled: !!maskUrl,
    staleTime: Infinity,
    // Keep current-case previews visible while the same mask is refreshed.
    // A changed URL must not inherit geometry from another case or mask.
    placeholderData: (previous, query) => (query?.queryKey[1] === maskUrl ? previous : undefined),
    queryFn: async ({ signal }) => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/labeling/proxy-mask?url=${encodeURIComponent(maskUrl!)}`,
        { signal },
      );
      if (!response.ok) throw new Error(`Saved card mask failed: ${response.status}`);
      return summarizeSavedMask(new Uint8Array(await response.arrayBuffer()));
    },
  });
}
